export class AssetDisplayConfig {
    constructor(name, symbol, color) {
        this.name = name;
        this.symbol = symbol;
        // this.icon = icon;
        this.color = color;
    }
    getName() {
        return this.name;
    }
    getSymbol() {
        return this.symbol;
    }
    // public getIcon(): string {
    //   return this.icon;
    // }
    getColor() {
        return this.color;
    }
}
//# sourceMappingURL=AssetDisplayConfig.js.map